// extracted by mini-css-extract-plugin
module.exports = {"info":"LoadingModal_info__37BK0","modal":"LoadingModal_modal__2y0gp","contentCss":"LoadingModal_contentCss__3Xcf-"};